import { render, staticRenderFns } from "./ParticipantsListComponent.vue?vue&type=template&id=796d0088&scoped=true&"
import script from "./ParticipantsListComponent.vue?vue&type=script&lang=js&"
export * from "./ParticipantsListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsListComponent.vue?vue&type=style&index=0&id=796d0088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796d0088",
  null
  
)

export default component.exports